<template>
  <div class="Winners">
    <template>
      <v-card>
        <v-tabs v-model="tab" centered>
          <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
        </v-tabs>
      </v-card>
      <v-card>
        <v-tabs-items v-model="tab" class="mt-2">
          <v-tab-item>
            <v-card-text>
              <MyWinners />
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <UsersWinners />
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <IgnoreWinners />
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </template>
  </div>
</template>
<script>
import MyWinners from "./MyWinners.vue";
import UsersWinners from "./UsersWinners.vue";
import IgnoreWinners from "./IgnoreWinners.vue";

export default {
  name: "Winners",
  components: {
    MyWinners,
    UsersWinners,
    IgnoreWinners,
  },
  data: () => ({
    tab: 0,
    items: ["Мои Клиенты", "Клиенты сотрудников", "Игнорируемые клиенты"],
  }),
  watch: {
    tab() {
      this.setTitle(this.items[this.tab]);
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
